import { render, staticRenderFns } from "./InstalmentPayment.vue?vue&type=template&id=33d81268&scoped=true"
import script from "./InstalmentPayment.vue?vue&type=script&lang=js"
export * from "./InstalmentPayment.vue?vue&type=script&lang=js"
import style0 from "./InstalmentPayment.vue?vue&type=style&index=0&id=33d81268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d81268",
  null
  
)

export default component.exports